import { render } from "./CustomerBroadcastBanner.vue?vue&type=template&id=6c6a4810"
import script from "./CustomerBroadcastBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBroadcastBanner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/CustomerBroadcastBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6a4810"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6a4810', __exports__)) {
    api.reload('6c6a4810', __exports__)
  }
  
  module.hot.accept("./CustomerBroadcastBanner.vue?vue&type=template&id=6c6a4810", () => {
    api.rerender('6c6a4810', render)
  })

}


export default __exports__